// extracted by mini-css-extract-plugin
export default {"confirm-pop-up":"ConfirmPopUp_confirm-pop-up__a0H59","confirm-buttons":"ConfirmPopUp_confirm-buttons__8ucrt"};